import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cancel-flow" }
const _hoisted_2 = { class: "cancel-flow__layout" }
const _hoisted_3 = { class: "cancel-flow__copy" }
const _hoisted_4 = {
  key: 0,
  class: "cancel-flow__loading",
  "aria-busy": "true"
}
const _hoisted_5 = { class: "cancel-flow__illustration" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
    "custom-class": "cancel-flow-dialog",
    width: "90%",
    top: "5vh",
    "show-close": false,
    "append-to-body": "",
    onClosed: _ctx.onClosed
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "cancel-flow__close",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onExit && _ctx.onExit(...args)))
        }, [
          _createVNode(_component_Icon, { icon: _ctx.mdiClose }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.ready)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent), {
                  key: 1,
                  stats: _ctx.stats,
                  "stats-available": _ctx.statsAvailable,
                  "period-end-label": _ctx.periodEndLabel,
                  reasons: _ctx.reasons,
                  "selected-reasons": _ctx.selectedReasons,
                  "other-text": _ctx.otherText,
                  path: _ctx.path,
                  finalizing: _ctx.isFinalizing,
                  "error-message": _ctx.cancelError || _ctx.feedbackError,
                  claiming: _ctx.isClaiming,
                  "offer-label": _ctx.acceptedOfferLabel,
                  "discount-label": _ctx.appliedDiscountLabel,
                  onNext: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goNext())),
                  onStay: _ctx.onExit,
                  onClaim: _ctx.onClaim,
                  onDecline: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goNext('decline'))),
                  onDone: _ctx.onDone,
                  onToggleReason: _ctx.onToggleReason,
                  "onUpdate:otherText": _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOtherText($event)))
                }, null, 40, ["stats", "stats-available", "period-end-label", "reasons", "selected-reasons", "other-text", "path", "finalizing", "error-message", "claiming", "offer-label", "discount-label", "onStay", "onClaim", "onDone", "onToggleReason"]))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.activeIllustration,
              class: "cancel-flow__illustration-img",
              alt: ""
            }, null, 8, _hoisted_6)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
}